import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "paginated-select__values__container" }
const _hoisted_3 = { class: "paginated-select__values" }
const _hoisted_4 = ["for", "onClick"]
const _hoisted_5 = ["id", "value", "onInput"]
const _hoisted_6 = {
  key: 1,
  class: "label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "select__triangle" }, null, -1)

import { request } from "@/domains/api/api";
import { relations, RelationConfigType } from "@/domains/search/config";
import {
    nextTick,
    ref,
    computed,
    onMounted,
    onUnmounted,
    ComputedRef,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { dispatch, onMessage } from "../bus";
import { ResourceFormStateFactory } from "../forms";
import { useLoading } from "../loading";
import { PaginatedResourcesState, Resource } from "../resource";
import SuspenseText from "@/domains/suspense-text/components/SuspenseText.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    configCol: null,
    value: null,
    getQueryParams: null,
    formFactory: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: "input", v: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    configCol: string;
    value: number | null;
    getQueryParams?: () => ComputedRef<Record<string, string>>;
    formFactory?: ResourceFormStateFactory<any>;
}





if (!relations[props.configCol]) throw "Cannot find resource config";

const { getState, getLabel, loadingKey } = relations[
    props.configCol
] as RelationConfigType;
const { loading } = useLoading(loadingKey);

const state = getState(
    props.getQueryParams ? props.getQueryParams() : undefined
);
if ((state as PaginatedResourcesState<any>).nextPage === undefined) {
    throw "Config state is not a paginated state";
}
const { data, loadNextPage, search, hasNextPage, refresh, canCreate } =
    state as PaginatedResourcesState<any>;

const mapped = computed(() => {
    return data.value.map((v) => ({
        label: getLabel(v),
        value: v.id as number,
    }));
});

const searchPayload = ref("");
const selectableValues = computed(() => {
    if (search || searchPayload.value === "") return mapped.value;
    return mapped.value.filter((v) =>
        v.label.toUpperCase().includes(searchPayload.value.toUpperCase())
    );
});

let fetchItemstimeout = ref(0);
function onType(event: Event) {
    searchPayload.value = (event.target as HTMLInputElement).value;

    if (fetchItemstimeout.value) {
        window.clearTimeout(fetchItemstimeout.value);
    }
    fetchItemstimeout.value = setTimeout(() => {
        if (search) {
            search(searchPayload.value);
        }
        fetchItemstimeout.value = 0;
    }, 800);
}

async function openSearch() {
    forceShowInput.value = true;
    opened.value = true;

    nextTick(() => {
        searchInput.value?.focus();
        forceShowInput.value = false;
    });
}

function loadMore() {
    if (!hasNextPage.value) return;
    if (searchInput.value) {
        searchInput.value.setAttribute("readonly", "true");
        searchInput.value?.focus();
        setTimeout(() => {
            searchInput.value?.removeAttribute("readonly");
            loadMoreBtn.value?.scrollIntoView();
        }, 100);
    }
    loadNextPage();
}

const forceShowInput = ref(false);
const searchInput = ref<HTMLInputElement | null>(null);
const loadMoreBtn = ref<HTMLButtonElement | null>(null);
const opened = ref(false);
const router = useRouter();
const route = useRoute();

function select(item: { value: number; label: string }) {
    if (props.value !== item.value) emit("input", item.value);
    closeSelect();
}

function closeSelect() {
    forceShowInput.value = true;
    nextTick(() => {
        searchInput.value?.focus();
        nextTick(() => {
            searchInput.value?.blur();
            forceShowInput.value = false;
            opened.value = false;
        });
    });
}

function openModal() {
    if (props.formFactory) {
        const removeListener = onMessage<string>(
            "field.create.relation.created",
            (key) => {
                if (key === props.configCol) {
                    refresh();
                }
                removeListener();
            }
        );
        dispatch("field.create.relation", {
            factory: props.formFactory,
            key: props.configCol,
        });
    }
}

async function getDisplayLabel(val: number | null): Promise<string> {
    if (val === null || isNaN(val) || val <= 0) return "";
    const label = selectableValues.value.find(
        (item) => item.value === val
    )?.label;
    if (label) return label;
    const resourceName = loadingKey.split(".")[0];
    return await request<Resource>(resourceName + "/" + val, "get").then(
        (data) => {
            if (!data) return "";
            return getLabel(data);
        }
    );
}

let removeGuard: () => void;

onMounted(() => {
    router.beforeEach((_to, from, next) => {
        if (
            from.name === route.name &&
            opened.value &&
            window.innerWidth < 500
        ) {
            next(false);
            closeSelect();
            return;
        }
        next();
    });
});

onUnmounted(() => {
    if (removeGuard) removeGuard();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["paginated-select select__container", { expanded: opened.value }])
  }, [
    _createElementVNode("p", {
      class: "paginated-select__value",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openSearch()))
    }, [
      _createVNode(SuspenseText, {
        promise: getDisplayLabel(__props.value)
      }, null, 8, ["promise"])
    ]),
    _withDirectives(_createElementVNode("input", {
      autocomplete: "off",
      ref_key: "searchInput",
      ref: searchInput,
      class: "paginated-select__search",
      placeholder: "Rechercher ...",
      id: 'paginated-select-' + __props.configCol + '__search',
      onKeyup: onType,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchPayload).value = $event))
    }, null, 40, _hoisted_1), [
      [_vShow, forceShowInput.value],
      [_vModelText, searchPayload.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (!_unref(loading) && _unref(fetchItemstimeout) <= 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectableValues), (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.value
                }, [
                  _createElementVNode("label", {
                    for: 'value-' + item.value,
                    class: _normalizeClass(["label", { selected: item.value === __props.value }]),
                    onClick: _withModifiers(($event: any) => (select(item)), ["prevent"])
                  }, _toDisplayString(item.label), 11, _hoisted_4),
                  _createElementVNode("input", {
                    id: 'value-' + item.value,
                    type: "radio",
                    name: "value",
                    value: item.value,
                    onInput: ($event: any) => (select(item))
                  }, null, 40, _hoisted_5)
                ], 64))
              }), 128)),
              (_unref(canCreate) && __props.formFactory !== undefined)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: openModal
                  }, " Nouveau "))
                : _createCommentVNode("", true),
              (_unref(hasNextPage))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (loadMore())),
                    class: "btn btn-secondary mt-1",
                    ref_key: "loadMoreBtn",
                    ref: loadMoreBtn
                  }, " Charger plus ", 512))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(fetchItemstimeout) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Chargement ..."))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, opened.value]
      ])
    ]),
    _hoisted_7
  ], 2))
}
}

})